<template>
    <hts-drawer
        v-model="visible"
        :title="$t('labels.vehicleRepairAdd')"
        :submit="handleSubmit"
        :rules="rules"
        @close="close">
        <hts-card>
            <hts-select-vehicle
                v-model="formData.vehicle"
                v-model:name="formData.licensePlate"
                :label="$t('labels.vehicle')"
                name-select="vehicle"
                prop="vehicle"
                required />

            <hts-form-date
                v-model="formData.repairDate"
                :label="$t('labels.repairDate')"
                name="repairDate"
                prop="repairDate"
                required />

            <hts-form-select
                v-model="formData.repairType"
                :label="$t('labels.repairType')"
                :items="repairTypes"
                key-id="key"
                key-label="label"
                required
                name="repairType"
                prop="repairType" />

            <hts-form-input
                v-model="formData.repairCost"
                type="number"
                :label="$t('labels.repairCost')"
                name="repairCost"
                prop="repairCost"
                required />

            <hts-select-cooperator
                v-model="formData.repairAgency"
                v-model:name="formData.repairAgencyAbbreviationName"
                :label="$t('labels.repairAgency')"
                type-cooperator="VENDOR"
                required
                prop="repairAgency"
                name-select="repairAgency"
                key-label="abbreviationName"
                key-sub-label="name" />

            <hts-form-textarea
                v-model="formData.description"
                :label="$t('labels.description')"
                name="description"
                prop="description" />
            <!--  -->
            <hts-form-file
                ref="file"
                v-model="formData.documents"
                type="file"
                :label="$t('labels.document')"
                name="document"
                prop="document"
                multiple />
        </hts-card>
    </hts-drawer>
</template>
<script setup lang="ts">
const visible = ref(false)

const emits = defineEmits(['refreshTables'])

const rules = {
  vehicle: 'required',
  repairDate: 'required',
  repairType: 'required',
  repairCost: 'required|gte:0',
  repairAgency: 'required'
}

const repairTypes = [
  {
    key: 'MAJOR_REPAIR',
    label: 'Sửa chữa lớn'
  },
  {
    key: 'MINOR_REPAIR',
    label: 'Sửa chữa nhỏ'
  }
]

const formData = ref<{ [key: string]: any }>({
  vehicle: '',
  licensePlate: '',
  repairDate: '',
  repairType: '',
  repairCost: null,
  repairAgency: '',
  repairAgencyAbbreviationName: '',
  description: '',
  documents: null
})

const open = () => {
  visible.value = true
}

const handleSubmit = async () => {
  const api = $url.vehicle.repair.add

  const dataForm = new FormData()
  dataForm.append('vehicle', formData.value.vehicle)
  dataForm.append('licensePlate', formData.value.licensePlate)
  dataForm.append('repairDate', formData.value.repairDate)
  dataForm.append('repairType', formData.value.repairType)
  dataForm.append('repairCost', formData.value.repairCost)
  dataForm.append('repairAgency', formData.value.repairAgency)
  dataForm.append('repairAgencyAbbreviationName', formData.value.repairAgencyAbbreviationName)
  dataForm.append('description', formData.value.description || '')

  Array.from((formData.value.documents || []) as FileList)?.forEach((file: File) => {
    dataForm.append('documents', file)
  })
  const data: any = await $api(api, { body: dataForm })

  const resData: any = data?.data?.value
  if (resData?.success) {
    process.client && $toast().success($t('labels.addSuccess'))
    emits('refreshTables')
    resetFormData()
    close()
  }
}

const resetFormData = () => {
  formData.value = {
    vehicle: '',
    licensePlate: '',
    repairDate: '',
    repairType: '',
    repairCost: null,
    repairAgency: '',
    repairAgencyAbbreviationName: '',
    description: '',
    documents: null
  }
}

const close = () => {
  visible.value = false
}

defineExpose({
  open
})
</script>
